import React from 'react';

export default function MessageListInitialLoader({ isDarkMode }) {
  const bar = `rounded animate-pulse ${isDarkMode ? 'bg-gray-600' : 'bg-gray-200'}`;

  return (
    <div className="max-w-4xl mx-auto w-full space-y-4 mt-2">
      <div className="flex justify-end">
        <div className={`border-r-2 px-3 py-2 ${isDarkMode ? 'border-gray-600 bg-gray-700' : 'border-gray-300 bg-gray-50'}`}>
          <div className={`h-4 w-32 ${bar}`}></div>
        </div>
      </div>

      <div className="w-full animate-pulse">
        <div className={`overflow-hidden rounded-xl border shadow-sm ${isDarkMode ? 'border-gray-700 bg-[#1f2937]' : 'border-gray-200 bg-white'}`}>
          <div className={`flex items-center justify-between border-b px-5 py-3 ${isDarkMode ? 'bg-indigo-900 border-indigo-800' : 'bg-indigo-50 border-gray-200'}`}>
            <div className={`h-4 w-44 ${bar}`}></div>

            <div className="flex gap-3">
              <div className={`h-5 w-5 rounded-md ${bar}`}></div>
              <div className={`h-5 w-5 rounded-md ${bar}`}></div>
              <div className={`h-5 w-5 rounded-md ${bar}`}></div>
            </div>
          </div>

          <div className="px-6 py-5">
            <div className={`mb-5 h-5 w-44 ${bar}`}></div>

            <div className="mb-5 space-y-3">
              <div className={`h-4 w-full ${bar}`}></div>
              <div className={`h-4 w-[95%] ${bar}`}></div>
              <div className={`h-4 w-[85%] ${bar}`}></div>
            </div>

            <div className="mb-5 space-y-3">
              <div className={`h-4 w-full ${bar}`}></div>
              <div className={`h-4 w-[92%] ${bar}`}></div>
              <div className={`h-4 w-[75%] ${bar}`}></div>
            </div>

            <div className="space-y-3">
              <div className={`h-4 w-full ${bar}`}></div>
              <div className={`h-4 w-[88%] ${bar}`}></div>
              <div className={`h-4 w-[70%] ${bar}`}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
